module.exports = __webpack_public_path__ + "media/images/lb/601-ad5fe5beb6fa4086223cef580ef45f38.svg";